<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.intensity"
            :error-messages="intensityErrors"
            :label="$t('priority.intensity')"
            required
            @input="$v.item.intensity.$touch()"
            @blur="$v.item.intensity.$touch()"
          />
        </v-col>

      </v-row>
      <v-row>

        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('priority.init') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.init"
                :error-messages="initErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'PriorityForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
  },
  data() {
    return {
        name: null,
        intensity: null,
        init: null,
    };
  },
  computed: {

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },

    intensityErrors() {
      const errors = [];

      if (!this.$v.item.intensity.$dirty) return errors;

      has(this.violations, 'intensity') && errors.push(this.violations.intensity);

      !this.$v.item.intensity.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    initErrors() {
      const errors = [];

      if (!this.$v.item.init.$dirty) return errors;

      has(this.violations, 'init') && errors.push(this.violations.init);


      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
  },
  validations: {
    item: {
      name: {
        required,
      },
      intensity: {
        required,
      },
      init: {

      },
    }
  }
};
</script>
